import { Link as RouterLink } from "react-router";

import { Link as MuiLink, TypographyVariant } from "@mui/material";

import { clientPath } from "@/router/ClientRoutes";
import { useTranslation } from "@/translations";

interface Props {
  clientId: string;
  caseNoteId: string;
  label: string;
  variant?: TypographyVariant;
}

/**
 * Navigable link to a single Aktenvermerk. Opens the client's Vermerke tab with the note
 * pre-selected.
 */
export function CaseNoteLink({ clientId, caseNoteId, label, variant }: Props) {
  const { t } = useTranslation();

  return (
    <MuiLink
      component={RouterLink}
      to={clientPath.caseNote({ id: clientId, noteId: caseNoteId })}
      onClick={(e) => e.stopPropagation()}
      aria-label={t("clients.openCaseNote", { label })}
      underline="hover"
      variant={variant}
      sx={{ fontWeight: 700, color: "text.primary" }}
    >
      {label}
    </MuiLink>
  );
}
